/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.24/esri/copyright.txt for details.
*/
import{getDefaultUnitForView as t}from"../core/unitUtils.js";const r={readOnly:!0,get(){return t(this.view)}};export{r as defaultUnitPropertyMetadata};
